import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'

import DestinationTags from './DestinationTags'
import { brandCurrencyPrefixes, brandCurrencySuffixes } from '../../../configuration/brand'
import labels from '../../../configuration/labels'
import { toggleAccommodationModal } from '../../../redux/actions/toggleAccommodationModal'
import { getDisplayBookButtons } from '../../../redux/reducers/configuration';
import '../../../styles/scss/elements/hero.scss'

const HeroDetailsAmtrak = props => {
  const {
    brand,
    containerClasses,
    discountText,
    title,
    tags,
    numDays,
    numDestinations,
    price,
    roundTripUpgradePrice,
    softripBooking,
  } = props

  const dispatch = useDispatch()
  const displayBookButtons = useSelector(getDisplayBookButtons)

  function toggleAccommModal() {
    dispatch(toggleAccommodationModal(window.scrollY))
  }

  const extraClasses = discountText ? 'with-discount' : ''

  const displayDestinationTags = softripBooking ? _.size(tags) > 1 : !_.isEmpty(tags)

  return (
    <div className={ containerClasses ? `hero-details ${containerClasses} ${extraClasses}` : `hero-details ${extraClasses}` }>
      {discountText && (
        <div
          className="hero-details__discount"
          dangerouslySetInnerHTML={{ __html: discountText }}
        />
      )}
      <div className="hero-details__content-container">
        <h1>{title}</h1>
        {displayDestinationTags && <DestinationTags destinations={tags} />}

        {!!roundTripUpgradePrice && (
          <p className="hero-details__round-trip-upgrade">
            Rather take the train? Upgrades start from {brandCurrencyPrefixes[brand] || '$'}{roundTripUpgradePrice}{brandCurrencySuffixes[brand] || ''}. Call for more details.
          </p>
        )}
        <div className="hero-details__content-container__lower">
          <div className="hero-details__content-container__lower__numbers">
            <p>
              <strong>{numDays} </strong>
              {`${labels.day}${numDays > 1 ? 's' : ''}`}
            </p>
            {numDestinations > 1 && (
              <p>
                <strong>{numDestinations} </strong>
                {`${labels.destination}${numDestinations > 1 ? 's' : ''}`}
              </p>
            )}
          </div>
          {!softripBooking && (
            <button
              className="hero-details__content-container__lower__cta"
              disabled={!displayBookButtons}
              onClick={toggleAccommModal}
            >
              <span className="hero-details__content-container__lower__cta__from">
                {`${labels.from} `}
              </span>
              <span className="hero-details__content-container__lower__cta__price">
                {price}
              </span>
              <div className="hero-details__content-container__lower__cta__price-suffix">
                <span>{brandCurrencySuffixes[brand]}</span>
                <span>pp</span>
              </div>
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default HeroDetailsAmtrak
